import React, { Component, Fragment } from "react";

export default class League extends Component {
  state = {
    index: this.props.index,
    id: this.props.league.id,
    teams: this.props.leagueTeams,
    matchPlan: this.props.league.matchPlan,
    campaignId: this.props.league.campaignId,
  };

  getTeamAveragePoints(team, currentWeek) {
    let memberAmount = 1;
    memberAmount = team?.points?.weekPoints["amountOfUsers_week" + currentWeek];

    if (isNaN(memberAmount)) {
      memberAmount = 1;
    }
    if (team?.points?.weekPoints[currentWeek]) {
      let avgPoints = team?.points.weekPoints[currentWeek] / memberAmount;

      if (isNaN(avgPoints)) {
        avgPoints = 0;
      }

      return avgPoints;
    } else {
      return 0;
    }
  }

  getWeekAveragePointsLeagueTeams(currentWeek) {
    let leagueWeekTotalPoints = 0;
    this.state.teams.forEach((team) => {
      let memberAmount = 1;

      if (team.members.length > 1) {
        memberAmount = team.members.length;
      }
      if (team.points.weekPoints[currentWeek]) {
        leagueWeekTotalPoints +=
          team.points.weekPoints[currentWeek] / memberAmount;
      }
    });
    let leagueWeekAverage = leagueWeekTotalPoints / this.state.teams.length;
    return leagueWeekAverage;
  }

  render() {
    return (
      <div className="tile is-near-half is-flex-direction-column m-small box notification">
        <Fragment>
          <div className="league-header">
            <p>
              <b>ID: {this.state.id}</b>
              <br />
            </p>
            <b>
              Kampagne ID: {this.state.campaignId ? this.state.campaignId : ""}
            </b>
            <br />
            <div className="league-team p-small">
              <b>Hold: {Object.keys(this.state.teams).length}</b>

              <ul className="is-flex flex-row">
                {Object.keys(this.state.teams).map((key, idx) => {
                  return (
                    <li
                      className="league-team"
                      key={idx + this.state.teams[key].teamName}
                    >
                      {this.state.teams[key].teamName}
                    </li>
                  );
                })}
              </ul>
            </div>
            <br></br>
          </div>
          <div>
            <b>Kampprogram: </b>
            <br />

            <ul className="tile is-parent flex-wrap">
              {Object.keys(this.state.matchPlan).map((key, idx) => {
                return (
                  <li
                    className="league"
                    key={key + idx + this.state.matchPlan[key]}
                  >
                    <h2 style={{ fontWeight: 800 }}>Uge {key}</h2>
                    {this.state.matchPlan[key].map((match, idx) => {
                      if (match == "average") {
                        return (
                          <div
                            key={
                              this.getWeekAveragePointsLeagueTeams(key).toFixed(
                                2
                              ) + key
                            }
                          >
                            <p>Alle mod gennemsnittet</p>
                            <p>
                              GNS LIGA POINT:{" "}
                              {this.getWeekAveragePointsLeagueTeams(
                                key
                              ).toFixed(2)}
                            </p>
                            {this.state.teams.map((team) => {
                              return (
                                <>
                                  <p className="league-match">
                                    {team.teamName}
                                    {"  "}{" "}
                                    {this.getTeamAveragePoints(team, key) >
                                    this.getWeekAveragePointsLeagueTeams(
                                      key
                                    ) ? (
                                      <b style={{ color: "green" }}>V</b>
                                    ) : (
                                      <b style={{ color: "red" }}>T</b>
                                    )}
                                  </p>
                                  <p>
                                    {this.getTeamAveragePoints(
                                      team,
                                      key
                                    ).toFixed(2)}
                                  </p>
                                </>
                              );
                            })}
                          </div>
                        );
                      } else {
                        const team1 = this.state.teams.find(
                          (team) => team.id == match[0]
                        );
                        const team2 = this.state.teams.find(
                          (team) => team.id == match[1]
                        );

                        let team1AvgWeekPoints = this.getTeamAveragePoints(
                          team1,
                          key
                        );
                        let team2AvgWeekPoints = this.getTeamAveragePoints(
                          team2,
                          key
                        );

                        return (
                          <p
                            className="league-match"
                            key={
                              match[idx] +
                              key +
                              team1?.teamName +
                              team2?.teamName
                            }
                          >
                            {team1?.teamName ? team1.teamName : "Gennemsnittet"}
                            {"  "}
                            {team1AvgWeekPoints > team2AvgWeekPoints ? (
                              <b style={{ color: "green" }}>V</b>
                            ) : (
                              <b style={{ color: "red" }}>T</b>
                            )}
                            <br />
                            Point: {"  "}
                            <b>
                              {team1
                                ? team1.points?.weekPoints[key]
                                  ? team1.points.weekPoints[key]
                                  : 0
                                : 0}{" "}
                            </b>
                            <br />
                            Pr pers: {"  "}
                            <b> {team1AvgWeekPoints.toFixed(2)}</b>
                            <br />
                            {"  "} vs {"  "}
                            <br />
                            {team2?.teamName ? team2.teamName : "Gennemsnittet"}
                            {"  "}
                            {team2AvgWeekPoints > team1AvgWeekPoints ? (
                              <b style={{ color: "green" }}>V</b>
                            ) : (
                              <b style={{ color: "red" }}>T</b>
                            )}
                            <br />
                            Point: {"  "}
                            <b>
                              {team2
                                ? team2.points?.weekPoints[key]
                                  ? team2.points.weekPoints[key]
                                  : 0
                                : 0}{" "}
                            </b>
                            <br />
                            Pr pers: {"  "}
                            <b>{team2AvgWeekPoints.toFixed(2)}</b>
                            <br />
                            <br />
                          </p>
                        );
                      }
                    })}
                  </li>
                );
              })}
            </ul>
          </div>
        </Fragment>
      </div>
    );
  }
}
